/**
 * Форматирует график работы в HTML строку
 * @param workingHours - График работы
 * @param ascentTime - Время на подъем
 * @param descentTime - Время на спуск
 * @returns HTML строка с отформатированным графиком
 */
export const formatWorkingHoursHtml = (
  workingHours: string | null | undefined,
  ascentTime: string | null | undefined,
  descentTime: string | null | undefined,
): string => {
  const hours = workingHours ? `${workingHours}` : "";
  const ascent = ascentTime ? `На подъем до ${ascentTime}` : "";
  const descent = descentTime ? `На спуск до ${descentTime}` : "";

  return [hours, ascent, descent]
    .filter(Boolean)
    .map((item) => `<p>${item}</p>`)
    .join("");
};
